const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export default [
  '$state', 'CustomerService', 'UserDataService', 'OrderService', 'ErrorHandler',
  class OrderHistoryCtrl {
    constructor($state, customerService, userData, orderService, errorHandler) {
      this._$state = $state;
      this._orderService = orderService;
      this._errorHandler = errorHandler;

      this.orders = [];
      this.loading = true;
      userData.getUserData()
        .then((res) => this.currentUser = res.user)
        .then(() => customerService.getOrderHistory(this.currentUser.user_info.public_name))
        .then((res) => this.orders = res.results)
        .finally(() => this.loading = false);
    }

    viewDetails(order) {      
      this._orderService.getBaseOrder(order.order_num, order.order_customer.address.zip)
        .then((res) => this._$state.go('order-summary', { order: res }))
        .catch(err => this._errorHandler.throwError('Order Lookup Error', err && err.data && err.data.message ? err.data.message : 'Encountered an error while attempting to retrieve order.', {
          rawError: err
        }));
    }

    itemss(items) {
      if (items === 1) {
        return `${items} item`;
      }
      return `${items} items`;
    }

    formatDate(date) {
      let d = new Date(date);
      return `${months[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
    }

    paymentMethod(transaction) {
      if (transaction.payment_type == 'PAYPAL') {
        return 'PayPal';
      }
      if (transaction.payment_type == 'AMAZON') {
        return 'Amazon';
      }
      return 'Credit Card';
    }

    formatAddress(address) {
      let addrString = '';

      addrString += address.street_1;
      if (address.street_2) addrString += ` ${address.street_2}`;
      addrString += `, ${address.city}`;
      if (address.state) addrString += `, ${address.state}`;
      if (address.zip) addrString += ` ${address.zip}`;
      if (address.country && address.country != 'US') addrString += ` ${address.country}`;

      return addrString;
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/pages/my-account/order-history.ctrl.js